import { useState, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import useDebounce from "./hooks/useDebounce";
import axios from "axios";
import { useSelector } from "react-redux";
import ModalWrapper from "./components/modal/ModalWrapper";
import EnquireModal from "./components/modal/EnquireModal";
import "./assets/styles/component_style.css";
import Cdil_Dark_Logo from "./assets/images/logo.webp";
import Footer from "./components/Footer";
import SearchIcon from "./assets/images/search.svg";
import RightChevronIcon from "./assets/images/chevronRight.svg";
import DownChevronIcon from "./assets/images/chevron-down.svg";
import MenuIcon from "./assets/images/menuIcon.svg";
import handleErrors from "./utils/handleErrors";
import "./assets/styles/topHeader.css";


import { routes } from "./routes/Routes";


const App = () => {
  const showEnquireModal = useSelector((state) => state.modal.showEnquireModal);
  const [showBetaBanner, setShowBetaBanner] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [offCanvasPage, setOffCanvasPage] = useState(0);
  const [searchBoxInputVal, setSearchBoxInputVal] = useState("");
  const debouncedSearchBoxValue = useDebounce(searchBoxInputVal);
  const [searchResults, setSearchResults] = useState([]);
  const [industriesForNavbar, setIndustriesForNavbar] = useState([]);
  const router = createBrowserRouter(routes);

  const handleSearchChange = async () => {
    try {
      if (debouncedSearchBoxValue.length === 0) return;

      const universalSearchResults = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}/frontend/universalSearch`,
        params: { searchParams: debouncedSearchBoxValue },
      });

      setSearchResults(universalSearchResults.data.results);
    } catch (error) {
      console.log("Error in universal search: ", error);
      handleErrors({ error });
    }
  };

  useEffect(() => {
    handleSearchChange();
  }, [debouncedSearchBoxValue]);

  function toggleSearch() {
    var div = document.getElementById("mobileSearch");
    if (div.style.display === "none") {
      div.style.display = "block";
      document.body.classList.add("remove-scrolling");
    } else {
      div.style.display = "none";
      document.body.classList.remove("remove-scrolling");
      setSearchBoxInputVal("");
    }
  }

  async function getIndustriesForNavbar(flag) {
    try {
      if (flag === "dropdown") {
        if (showDropdown) {
          setIndustriesForNavbar([]);
          setShowDropdown(false);
        } else {
          const getIndustriesForNavbarResults = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_BACKEND_URL}/frontend/industry/all`,
          });
          setIndustriesForNavbar(getIndustriesForNavbarResults.data.rows.map(industry => ({
            name: industry,
            navigate: `/table/category/all/all?industry=${industry}`
          })));
          setShowDropdown(true);
        }
      } else if (flag === "offcanvas") {
        if (offCanvasPage === 0) {
          const getIndustriesForNavbarResults = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_BACKEND_URL}/frontend/industry/all`,
          });
          setIndustriesForNavbar(getIndustriesForNavbarResults.data.rows.map(industry => ({
            name: industry,
            navigate: `/table/category/all/all?industry=${industry}`
          })));
          setOffCanvasPage(1);
        } else if (offCanvasPage === 1) {
          setIndustriesForNavbar([]);
          setOffCanvasPage(0);
        }
      }
    } catch (error) {
      handleErrors({ error });
    }
  }

  return (
    <>
      {showEnquireModal && (
        <ModalWrapper>
          <EnquireModal />
        </ModalWrapper>
      )}
      {showBetaBanner && (
        <div className="beta-ticker" style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1001, background: "#1e3a8a", color: "#ffffff", textAlign: "center", fontSize: "13px", padding: "7px 16px", display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
          <span>This site is currently in beta testing. Found a bug or have feedback? <a href="/support" style={{ color: "#93c5fd", fontWeight: 600 }}>Share it with us via the Support page.</a></span>
          <button onClick={() => setShowBetaBanner(false)} style={{ background: "none", border: "none", color: "#ffffff", fontSize: "18px", cursor: "pointer", lineHeight: 1, padding: "0 4px", opacity: 0.7 }}>×</button>
        </div>
      )}
      <header className="top-header-wrapper" style={{ position: "fixed", top: showBetaBanner ? "34px" : 0, left: 0, right: 0, zIndex: 1000 }}>
        <div className="container top-header-inner">
          {/* Logo */}
          <a href="/" className="navbar-brand">
            <img src={Cdil_Dark_Logo} alt="CDIL" className="logo" />
          </a>

          {/* Center: Nav + Search */}
          <div className="top-center">
            <nav className="top-nav">
              <a href="/">Home</a>
              <a href="/category">Products</a>
            </nav>
            <div className="search desktop">
              <input
                className="search-input"
                type="text"
                placeholder="Search products, categories..."
                value={searchBoxInputVal}
                onChange={(e) => setSearchBoxInputVal(e.target.value)}
                onBlur={() => setTimeout(() => setSearchResults([]), 200)}
              />
              {searchResults.length > 0 && (
                <div className="search-dropdown">
                  {searchResults.map((item, i) => (
                    <a key={i} href={`${process.env.REACT_APP_BASE_URL}${item.navigate}`} className="search-item">
                      <span>{item.name}</span>
                      <small>{item.type.toUpperCase()}</small>
                    </a>
                  ))}
                </div>
              )}
              {searchBoxInputVal.length > 0 && searchResults.length === 0 && (
                <div className="search-dropdown">
                  <div className="no-result">No results found</div>
                </div>
              )}
            </div>
          </div>

          {/* Right: Buttons + Mobile Icons */}
          <div className="top-actions">
            <div className="mobile-actions">
              <button onClick={() => setShowOffCanvas(true)}>
                <img src={MenuIcon} alt="" />
              </button>
              <div onClick={toggleSearch}>
                <img src={SearchIcon} alt="" />
              </div>
            </div>
            <a href="/support" className="contact-btn desktop-only">
              Contact Us
            </a>
            <a href="https://www.cdil.com" className="contact-btn desktop-only" target="_blank" rel="noreferrer" style={{ background: "none", border: "1px solid #d1d5db", color: "#374151" }}>
              Back to Main Site
            </a>
          </div>
        </div>

      {/* Offcanvas for Mobile Menu */}

      {/* ================= MOBILE NAV ================= */}
    
  </header>
      <div
        className={`offcanvas offcanvas-start ${showOffCanvas ? "show" : ""}`}
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
        style={{ maxWidth: "280px" }}
      >
        {offCanvasPage === 0 ? (
          <>
            <div
              className="offcanvas-header"
              onClick={() => setShowOffCanvas(false)}
            >
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
              <p
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                style={{ fontSize: "1rem" }}
              >
                Close
              </p>
            </div>
            <div className="offcanvas-body">
              <div className="dropdown">
                <ul className="navbar-nav">
                  <li className="nav-item" style={{ fontSize: "1rem" }}>
                    <a
                      className="nav-link"
                      href="/"
                      style={{ color: "#323F5B" }}
                    >
                      Home 
                      <img src={RightChevronIcon} alt="" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="/category"
                      style={{ color: "#323F5B" }}
                    >
                      Category
                      <img src={RightChevronIcon} alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="offcanvas-header" onClick={() => setOffCanvasPage(0)}>
              <button type="button" className="btn-close text-reset"></button>
              <p style={{ fontSize: '1rem' }}>← Back</p>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav">
                {industriesForNavbar.map((industry, i) => (
                  <li key={i} className="nav-item">
                    <a className="nav-link" href={industry.navigate} style={{ color: '#323F5B' }}
                      onClick={() => setShowOffCanvas(false)}>
                      {industry.name}
                      <img src={RightChevronIcon} alt="" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>

      

      <RouterProvider router={router} />

      <Footer />

      <div
        className={`offcanvas-backdrop fade ${showOffCanvas ? "show" : "d-none"
          }`}
      ></div>
    </>
  );
};

export default App;
